import { Component, OnInit } from '@angular/core';
import { PopoverController, NavParams } from '@ionic/angular';
import {environment} from "../../../environments/environment";
import {TranslationService} from "../../services/translation.service";

@Component({
  selector: 'app-seeker-profile-reassign',
  templateUrl: './seeker-profile-reassign.component.html',
  styleUrls: ['./seeker-profile-reassign.component.scss'],
})
export class SeekerProfileReassignComponent implements OnInit {

  info: any = null;
  languages: any = [];
  communities: any = [];
  categories: any = [];
  abusive_note: any = '';
  leader_note: any = '';
  language_note: any ='';
  category_note: any ='';
  previousOM_note:string = '';
  note_field = false;
  note_field_leader = false;
  note_field_language= false;
  note_field_category= false;
  note_field_previousOM:boolean = false;
  language_id;
  category_uuid;
  categoryuuid;
  languageid;

  constructor(
    private popCtrl: PopoverController,
    private navParams: NavParams,
    private _translationService: TranslationService
  ) {

    this.info = this.navParams.get('event');

    if (this.info != null) {
      this.languages = this.info.languages;
      this.communities = this.info.communities;
      this.categories = this.info.categories;
      this.language_id = this.info.language_id;
      this.category_uuid = this.info.category_uuid;
      this.languageid = this.info.languageid
    }
  }


  ngOnInit() {
    this.categoryuuid = environment.CATEGORY_UUID;
    console.log(this.categoryuuid);
  }

  async dismiss() {
    await this.popCtrl.dismiss();
  }

  reassignSelect(selected: any, event: any) {
    this.reassign({ option: selected, selected: event.target.value,note: this.language_note || this.category_note});
  }

  reassign(selected: any) {
    if (selected === 'leader' || selected === 'pool' || selected === 'abusive' || selected.option === 'language' || selected.option === 'category' || selected === 'previous') {
      if (selected === 'abusive') {
        if (this.abusive_note.length===0) {
          alert(this._translationService.translate('Forgot To Enter Reassign Note'));
        } else {
          this.dismissWithSave({option: selected, note: this.abusive_note});
        }
      } else if (selected === 'leader') {
          if (this.leader_note.length === 0) {
            alert(this._translationService.translate('Forgot To Enter Reassign Note'));
          } else {
            this.dismissWithSave({option: selected, note: this.leader_note});
          }
      } else if (selected.option === 'language') {
        if (this.language_note.length === 0) {
          alert(this._translationService.translate('Forgot To Enter Reassign Note'));
          this.note_field_language = false;
        } else {
          this.dismissWithSave(selected);
        }
      } else if (selected.option === 'category') {
          if (this.category_note.length === 0) {
            alert(this._translationService.translate('Forgot To Enter Reassign Note'));
            this.note_field_category = false;
          } else {
            this.dismissWithSave(selected);
          }
      } else if (selected === 'previous') {
        if (this.previousOM_note.length === 0) {
          alert(this._translationService.translate('Forgot To Enter Reassign Note'));
          this.note_field_previousOM = false;
        } else {
          this.dismissWithSave({option: selected, note: this.previousOM_note});
        }

      } else {
        this.dismissWithSave(selected);
      }
    }
  }
  addnote(e) {
    if (e==='note_field') {
      if (this.note_field == true) {
        this.note_field = false;
      } else {
        this.note_field = true;
        this.note_field_leader = false;
        this.note_field_category = false;
        this.note_field_language = false;
        this.note_field_previousOM = false;
      }
    }
    if (e==='note_field_leader') {
        if (this.note_field_leader == true) {
          this.note_field_leader = false;
        } else {
          this.note_field_leader = true;
          this.note_field_previousOM = false;
          this.note_field_category = false;
          this.note_field = false;
          this.note_field_language = false
        }
      }
    if (e==='note_field_language') {
      if (this.note_field_language == true) {
        this.note_field_language = false
      } else {
        this.note_field_language = true;
        this.note_field_previousOM = false;
        this.note_field_category = false;
        this.note_field = false;
        this.note_field_leader = false
      }
    }
    if (e==='note_field_category') {
      if (this.note_field_category == true) {
        this.note_field_category = false
      } else {
        this.note_field_category = true;
        this.note_field_previousOM = false;
        this.note_field_language = false;
        this.note_field = false;
        this.note_field_leader = false
      }
    }
    if (e==='note_field_previousOM') {
      if (this.note_field_previousOM == true) {
        this.note_field_previousOM = false
      } else {
        this.note_field_previousOM = true;
        this.note_field_language = false;
        this.note_field = false;
        this.note_field_leader = false;
        this.note_field_category = false;
      }
    }
  }
  async dismissWithSave(data: any) {
    console.log('innnnnnnnnnnnnnnnnnnnnnnnn')
    await this.popCtrl.dismiss(data);
    window.history.back();
  }

  async closeConversation() {
    await this.popCtrl.dismiss('close');
  }
}
